var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import styled from '@mui/material/styles/styled';
import { Chip, chipClasses } from '@mui/material';
var ChipRoot = styled(Chip)(function (_a) {
    var _b, _c, _d, _e;
    var _f;
    var size = _a.size, theme = _a.theme, variant = _a.variant, color = _a.color, clickable = _a.clickable;
    return __assign(__assign(__assign(__assign((_b = {}, _b["& ." + chipClasses.label] = {
        paddingLeft: 11,
        paddingRight: 13,
        fontSize: 14,
    }, _b), (clickable === false && ({
        '&:hover': __assign({ cursor: 'pointer' }, (variant === 'outlined'
            ? {
                backgroundColor: theme.palette.action.hover,
            }
            : {
                backgroundColor: theme.palette[color] && ((_f = theme.palette[color]) === null || _f === void 0 ? void 0 : _f.main),
            })),
    }))), (size === 'small' && (_c = {
            height: '18px'
        },
        _c["& ." + chipClasses.labelSmall] = {
            paddingLeft: 7,
            paddingRight: 7,
            fontSize: 12,
        },
        _c))), (size === 'medium' && (_d = {
            height: '24px'
        },
        _d["& ." + chipClasses.labelMedium] = {
            paddingLeft: 7,
            paddingRight: 7,
            fontSize: 12,
        },
        _d["& ." + chipClasses.avatar] = {
            width: 18,
            height: 18
        },
        _d["& ." + chipClasses.deleteIconMedium] = {
            fontSize: 14,
        },
        _d))), (size === 'large' && (_e = {
            height: '32px'
        },
        _e["& ." + chipClasses.labelMedium] = {
            fontSize: 14,
        },
        _e["& ." + chipClasses.deleteIcon] = {
            fontSize: 18,
        },
        _e)));
});
ChipRoot.defaultProps = {
    variant: 'outlined',
    size: 'medium',
    clickable: false,
};
export default ChipRoot;
